import React from "react";
import { useTranslation } from "react-i18next";

import UserInfo from "../../etc/list/UserInfo";

const WebFriendList = ({ rowKey, list_friends }) => {
    const { t } = useTranslation();

    return (
        list_friends !== undefined && list_friends !== null && list_friends.length > 0 ?
            <table className="d-flex flex-column table table-sm table-hover mb-0">
                <tbody>
                    {
                        list_friends.map(friend => (
                            <UserInfo key={rowKey + friend.userSeq} user_info={friend} />
                        ))
                    }
                </tbody>
            </table> :
            <div className="view m-3 text-center grey-text">
                {t("친구_목록_없음", { ns: "friend" })}
            </div>
    );
}

export default WebFriendList;